import axios from "./index";

export default {
  getDropdown(region) {
    return axios.get(`/v1/setting/provinces/dropdown?region=${region}`);
  },
  getAllDropdown() {
    return axios.get(`/public/provinces`);
  },
};
